export const backToTopOfPage = () => {
  document.body.scrollTop = document.documentElement.scrollTop = 0;
};

export const removeFromFilesArray = (index: number, obj: any, array: any[]) => {
  const finalArray: typeof array = [];
  for (let i = 0; i < array.length; i++) {
    const element = array[i]; /* 
    const c1 = obj.name === element.name;
    const c2 = obj.size === element.size;
    const c3 = obj.type === element.type; */
    const c4 = index === i;
    /* console.log( new File([obj], "name"),element,index,i ) */
    if (c4) {
      /* console.log("match") */
    } else {
      finalArray.push(element);
    }
  }
  return finalArray;
};

export const waitTo = (milliseconds: number, action: () => void) => {
  setTimeout(() => {
    action();
  }, milliseconds);
};

const bgColors = [
  "rgba(103, 136, 161, 0.2)",
  "rgba(110, 179, 232, 0.2)",
  "rgba(120, 23, 234, 0.2)",
  "rgba(247, 86, 124, 0.2)",
  "rgba(18, 125, 82, 0.2)",
  "rgba(109, 193, 162, 0.2)",
  "rgba(199, 234, 23, 0.2)",
  "rgba(248, 155, 255, 0.2)",
];

export const getRandomBgColor = () => {
  const picker = Math.floor(Math.random() * (bgColors.length - 0 + 1)); 
  return bgColors[picker];
};
